export const PayoutsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.4}
      d="M10.688 3.5H7.312c-2.386 0-3.58 0-4.32.753-.741.753-.742 1.965-.742 4.39v1.714c0 2.424 0 3.637.742 4.39.74.753 1.934.753 4.32.753h3.375c2.387 0 3.58 0 4.322-.753s.741-1.965.741-4.39V8.643c0-2.424 0-3.637-.741-4.39-.742-.753-1.935-.753-4.322-.753Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.4}
      d="M5.25 6.5H7.5"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.4}
      d="M14.25 12.5h-1.5c-.707 0-1.06 0-1.28-.22-.22-.22-.22-.573-.22-1.28 0-.707 0-1.06.22-1.28.22-.22.573-.22 1.28-.22h1.5c.707 0 1.06 0 1.28.22.22.22.22.573.22 1.28 0 .707 0 1.06-.22 1.28-.22.22-.573.22-1.28.22Z"
    />
  </svg>
);
